import './Devices.css';

const DEVICES = [
  { id: '1', name: 'iPhone 15 Pro', platform: 'iOS 17', linked: 'Jan 10, 2026', lastActive: '5 min ago', status: 'active' },
  { id: '2', name: 'MacBook Pro', platform: 'macOS 14', linked: 'Jan 12, 2026', lastActive: '2 hours ago', status: 'idle' },
  { id: '3', name: 'Chrome Browser', platform: 'Web', linked: 'Jan 15, 2026', lastActive: 'Now', status: 'active' },
];

const PENDING_LINKS = [
  { id: 'p1', name: 'iPad Pro', platform: 'iPadOS 17', requested: '10 minutes ago' },
];

export default function Devices() {
  return (
    <div className="devices-page animate-in">
      {/* Header Actions */}
      <div className="page-actions">
        <button className="btn btn-primary">+ Link Device</button>
      </div>

      {/* Linked Devices */}
      <section className="devices-section">
        <h2 className="section-title">Linked Devices</h2>
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Device</th>
                <th>Platform</th>
                <th>Linked</th>
                <th>Last Active</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {DEVICES.map((device) => (
                <tr key={device.id}>
                  <td>
                    <span className="device-name">{device.name}</span>
                  </td>
                  <td>{device.platform}</td>
                  <td>{device.linked}</td>
                  <td>{device.lastActive}</td>
                  <td>
                    <span className={`status-indicator status-${device.status}`}>
                      <span className={`status-dot ${device.status}`}></span>
                      {device.status === 'active' ? 'Active' : 'Idle'}
                    </span>
                  </td>
                  <td>
                    <button className="btn-icon" title="More options">···</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Pending Link Requests */}
      {PENDING_LINKS.length > 0 && (
        <section className="devices-section">
          <h2 className="section-title">
            Pending Link Requests
            <span className="badge badge-warning">{PENDING_LINKS.length}</span>
          </h2>
          <div className="pending-links">
            {PENDING_LINKS.map((link) => (
              <div key={link.id} className="link-card card">
                <div className="link-info">
                  <span className="link-icon">📱</span>
                  <div className="link-details">
                    <span className="link-name">{link.name}</span>
                    <span className="link-platform">{link.platform}</span>
                    <span className="link-time">Requested: {link.requested}</span>
                  </div>
                </div>
                <div className="link-actions">
                  <button className="btn btn-primary">Approve with Spark</button>
                  <button className="btn btn-secondary">Deny</button>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
